export enum RevalidateValues {
  SECONDS = 2,
  MINUTE = 60,
  HOUR = 3600,
  HALF_DAY = 43200,
  DAY = 86400,
  WEEK = 604800,
}

export const getRevalidateDuration = (value: RevalidateValues) => {
  if (process.env.REVALIDATE_TIME && Number(process.env.REVALIDATE_TIME) > 0) {
    return Number(process.env.REVALIDATE_TIME);
  }
  return value;
};
